import HttpService from '../HttpService';


export default class InvoicingService {
  constructor() {
    this._httpService = new HttpService('/servicos/');
  }

  async FetchInvoices(params) {
    // return await this._httpService.get(`invoicing?${params}`);
    return {
      data: {
        totalPages: 2,
        totalElements: 1,
        content: [
          {
            id: 1,
            benefitType: "Saúde",
            carrierName: "Seguros SA",
            carrierId: 1001,
            cnpj: "12.345.678/0001-90",
            competencyDate: "2024-01-01",
            contractNumber: "CT-001",
            invoiceType: "Mensal",
            numberLives: 150,
            value: 75000.50,
            policy: "POL-2024-001",
            status: "Ativo",
            subContractId: 501,
            subContractNumber: "SUB-CT-001",
            limitDate: '2024-01-15',
            downloads: [
              {
                fileId: 201,
                fileName: "fatura_janeiro.pdf",
                userName: "João Silva",
                downloadDate: "2024-01-15"
              },
              {
                fileId: 202,
                fileName: "comprovante.pdf",
                userName: "João Silva",
                downloadDate: "2024-01-16"
              }
            ],
            bankSlipValue: 500.00,
            copayValue: 2500.00,
            iofValue: 300.00,
            isIntegrator: true,
            premiumValue: 72000.00,
            otherAmountsValue: 1500.50,
            replaceFeeValue: 0.00,
            settlementValue: 75000.50
          },
          {
            id: 2,
            benefitType: "Dental",
            carrierName: "OdontoPlus",
            carrierId: 1002,
            cnpj: "98.765.432/0001-10",
            competencyDate: "2024-02-01",
            contractNumber: "CT-002",
            invoiceType: "Mensal",
            numberLives: 75,
            value: 25300.00,
            policy: "POL-2024-002",
            status: "Pendente",
            subContractId: 502,
            subContractNumber: "SUB-CT-002",
            limitDate: '2024-01-15',
            downloads: [
              {
                fileId: 203,
                fileName: "fatura_fevereiro.pdf",
                userName: "Maria Santos",
                downloadDate: "2024-02-05"
              }
            ],
            bankSlipValue: 200.00,
            copayValue: 1200.00,
            iofValue: 150.00,
            isIntegrator: false,
            premiumValue: 24000.00,
            otherAmountsValue: 100.00,
            replaceFeeValue: 50.00,
            settlementValue: 25300.00
          },
          {
            id: 3,
            benefitType: "Vida",
            carrierName: "VidaSecurity",
            carrierId: 1003,
            cnpj: "11.223.334/0001-55",
            competencyDate: "2024-03-01",
            contractNumber: "CT-003",
            invoiceType: "Única",
            numberLives: 200,
            value: 45800.75,
            policy: "POL-2024-003",
            status: "Ativo",
            subContractId: 503,
            subContractNumber: "SUB-CT-003",
            limitDate: '2024-01-15',
            downloads: [],
            bankSlipValue: 0.00,
            copayValue: 0.00,
            iofValue: 420.25,
            isIntegrator: true,
            premiumValue: 45380.50,
            otherAmountsValue: 0.00,
            replaceFeeValue: 0.00,
            settlementValue: 45800.75
          }
        ]
      }
    };
  }

  async FetchProtocols(params) {
    return await this._httpService.get(`invoicing/protocols?${params}`);
  }

  Export(payload) {
    return this._httpService.post(`invoicing/export`, payload);
  }
}
